import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/unsubscribe/$token")({
  component: UnsubscribePage,
  head: () => ({
    meta: [
      { title: "Unsubscribe — RoleBoard" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
});

function UnsubscribePage() {
  const { token } = Route.useParams();
  const [state, setState] = useState<"loading" | "ok" | "error">("loading");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data, error } = await supabase.rpc("unsubscribe_digest_by_token", {
          feed_token: token,
        });
        if (cancelled) return;
        if (error || data !== true) setState("error");
        else setState("ok");
      } catch {
        if (!cancelled) setState("error");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <main className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center space-y-4 py-16">
        <img
          src="https://fqqcdjchitiluxplirkm.supabase.co/storage/v1/object/public/logos/RBBrand.png"
          alt="RoleBoard"
          width={140}
          className="mx-auto h-auto"
          style={{ width: 140 }}
        />
        {state === "loading" && (
          <p className="text-muted-foreground text-sm">Updating your preferences…</p>
        )}
        {state === "ok" && (
          <>
            <h1 className="text-2xl font-semibold text-foreground">
              You've been unsubscribed from weekly digests.
            </h1>
            <p className="text-muted-foreground text-sm">
              You won't receive them anymore.
            </p>
            <a
              href="https://roleboard.app"
              className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90 mt-2"
            >
              Back to RoleBoard
            </a>
          </>
        )}
        {state === "error" && (
          <>
            <h1 className="text-2xl font-semibold text-foreground">
              This unsubscribe link is invalid or has already been used.
            </h1>
            <a
              href="https://roleboard.app"
              className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90 mt-2"
            >
              Back to RoleBoard
            </a>
          </>
        )}
      </div>
    </main>
  );
}
